// Basic usage:
// <input v-focus />
//
// Select text instead of just focusing the element:
// <input v-focus.select />
//
// Persist focus, refocus when blurred (unless focus is set to another input field):
// <input v-focus.persist />
//
// Conditional focus:
// <input v-focus="shouldFocus" />

const focus = {
    install(Vue, options) {
        Vue.directive('focus', this);
    },
    inserted(el, binding) {
        focus.maybeFocus(el, binding);

        if (binding.modifiers.persist) {
            let handler = () => {
                Vue.nextTick(() => {
                    if (document.activeElement && document.activeElement.tagName.toLowerCase() === 'button')
                        focus.maybeFocus(el, binding);
                });
            };
            el.__vueBlurHandler__ = handler;
            el.addEventListener('blur', handler);
        }
    },
    unbind(el) {
        el.removeEventListener('blur', el.__vueBlurHandler__);
        delete el.__vueBlurHandler__;
    },
    componentUpdated(el, binding) {
        if (binding.value !== binding.oldValue)
            focus.maybeFocus(el, binding);
    },
    maybeFocus(el, binding) {
        if ('value' in binding && !binding.value)
            return;

        if (binding.modifiers.select)
            el.select();
        else
            el.focus();
    },
};

export default focus;
